import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
 

export default new Vuex.Store({
    state: {
        deviceId: null,
        deviceSecret: null,
        app: null,
        loaded: false,
        mqtt: null,
        awsCredentials: null
    },
    mutations: {
        setDeviceId: (state, payload) => state.deviceId = payload,
        setDeviceSecret: (state, payload) => state.deviceSecret = payload,
        setAwsCredentials: (state, payload) => state.awsCredentials = payload,
        setApp: (state, payload) => { 
            state.app = payload; 
            state.loaded = true; 
        },
        setMqtt: (state, payload) => state.mqtt = payload,
        updateItemValue: (state, payload) => state.app.items[payload.key].value = payload.value
    },
    getters: {
        hasValidAwsCredentials: (state) => {
            return state.awsCredentials && (new Date(state.awsCredentials.Expiration)).getTime()>(new Date()).getTime();
        },
        findItemByName: (state) => (name) => {
            var returnValue = null;
            if (state.app && state.app.items)
            {
                Object.keys(state.app.items).forEach(key => {
                    
                    if (state.app.items[key].name == name)
                    {
                        returnValue = state.app.items[key];
                    }
                })
            }
            

            return returnValue;
        },
        findItemsByDeviceId: (state) => (deviceId) => {
            var returnValues = {};
            if (state.app && state.app.items)
            {
                Object.keys(state.app.items).forEach(key => {
                    
                    if (state.app.items[key].deviceId && state.app.items[key].deviceId == deviceId)
                    {
                        returnValues[key] = state.app.items[key].fieldName;
                    }
                })
            }
            

            return returnValues;
        }
    }
    ,
    actions: {
    
    },
    plugins: [vuexLocal.plugin]
})
